import session from "../../../services/session";
import swal from "sweetalert2";
import AdminApi from '../../../services/api'
import CONFIG_COMPANY from "../../../services/myConfig";
import Loc from "../../../services/localization";
import UTILS from "../../../services/utils";

const AdminApiService = new AdminApi();
const LocService = new Loc()

export default {
    data() {
        return {
            locale: LocService,
            selectedImage: null,
            selectedImagePreview: null,
            imageUrl: null,
            idToEdit: null,

            categories: [],
            showAddCategory: false,
            newCategory: '',
            selectedCategory: "null",
            isLoadingCategory: false,

            title: LocService.t('label_ci_shop_add'),
            allCustomCategories: [],
            selectedCustomCategories: [],
            isAction: false,
            useCreditsToBuyForShop: false,
            visibleStockNumber: false,
            model: {
                orderNumber: 0,
                stockNumber: 0,
                name: '',
                enName: '',
                shortDescription: '',
                enShortDescription: '',
                longDescription: '',
                enLongDescription: '',
                imageHeader: null,
                imageMain: '',
                orderUuid: '',
                type: 'SHOP',
                price: null,
                purchasePrice: null,
                category: null,
                discount: null,
                creditForUse: 1,
                isCreditType: false,
                additionalInfo: {
                    price: null,
                    currency: 'RSD',
                    discount: null,
                    shopLink: null
                },
                locations: null,
                isMainAdmin: false,
                isEnableAddStockNumber: false,
            },

        }
    },
    methods: {
        addTraining: addTraining,
        editTraining: editTraining,
        getTrainingInfoById: getTrainingInfoById,
        editTrainingFromApi: editTrainingFromApi,
        loadTextFromFile: loadTextFromFile,
        reset: reset,
        isSelected: isSelected,
        populateItemToMakeAction: populateItemToMakeAction,
        populateItemToEdit: populateItemToEdit,
        getChipClass: getChipClass,
        clickSelectCustomCategory: clickSelectCustomCategory,
        addTrainingFromApi: addTrainingFromApi,
        uploadPhoto: uploadPhoto,
        addTypeCategory: addTypeCategory,
        deleteCategory: deleteCategory,
        getAllCategories: getAllCategories,
    },
    beforeMount() {
        if (session.getRole() !== 'ROLE_ADMIN' && session.getRole() !== 'ROLE_SUPER_ADMIN') {
            this.$router.push(CONFIG_COMPANY.HOME);
            return;
        }
        if(CONFIG_COMPANY.SPECIFIC_ROLES != null){
            if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()] != null){
                if(CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].ENABLE_ADD_STOCK_PRODUCT != null){
                    this.isEnableAddStockNumber = CONFIG_COMPANY.SPECIFIC_ROLES[session.getUsername()].ENABLE_ADD_STOCK_PRODUCT;
                }
            }
        }
        this.visibleStockNumber = session.getRole() === 'ROLE_SUPER_ADMIN'
        this.isMainAdmin = session.isMainAdmin();
        this.allCustomCategories = session.getConfig().customCategories.split(";");
        this.useCreditsToBuyForShop = session.getConfig().useCreditsToBuyForShop != null ? session.getConfig().useCreditsToBuyForShop : false;
        this.idToEdit = this.$route.query.id;
        this.isAction = this.$route.query.action == null ? false : this.$route.query.action;
        if(this.idToEdit != null){
            this.title = this.isAction ? LocService.t('label_action_for_item') : LocService.t('label_ci_shop_edit');
            this.getTrainingInfoById()
        }else{
            this.getAllCategories(true)
        }
    }
}

function deleteCategory(){
    let _self = this;
    if(this.selectedCategory == null) return;
    _self.isLoadingCategory = true
    AdminApiService.deleteTrainingDefinitionTypeCategory(this.selectedCategory.id)
        .then((response) => {
            _self.getAllCategories(false);
            _self.selectedCategory = "null"

        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getAllCategories(firstTime){
    let _self = this;
    AdminApiService.getTrainingDefinitionTypeCategory("SHOP_CATEGORY")
        .then((response) => {
            _self.categories = response.data
            _self.isLoadingCategory = false
            _self.showAddCategory = false;
            if(firstTime){
                var filtered = _self.categories.filter(c => c.name === _self.model.category)
                if(filtered.length > 0){
                    _self.selectedCategory = filtered[0]
                }
            }
        })
        .catch((error) => {
            this.isLoadingCategory = false;
            swal(LocService.t('label_error'), LocService.t('label_error'), 'error')
        })
}

function addTypeCategory(){
    let _self = this;
    let model = {
        name: _self.newCategory,
        type: "SHOP_CATEGORY"
    }
    if(model.name.length === 0) return;
    _self.isLoadingCategory = true
    AdminApiService.addTrainingDefinitionTypeCategory(model)
        .then((response) => {
            _self.getAllCategories(false);
            _self.newCategory = ""
        })
        .catch((error) => {
            _self.isLoadingCategory = false;
            swal(LocService.t('label_error'), error.data.localized_error_message, 'error')
        })
}

function getTrainingInfoById(){
    let _self = this;
    AdminApiService.getCompanyInfoById(this.idToEdit)
        .then((response) => {
            if(_self.isAction){
                _self.populateItemToMakeAction(response)
            }else{
                _self.populateItemToEdit(response)
            }
        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function populateItemToEdit(response){
    let _self = this;
    let addInfo = JSON.parse(response.data.additionalInfo)
    _self.imageUrl = response.data.imageMain
    _self.model.name = response.data.name
    _self.model.category = response.data.category
    _self.model.enName = response.data.enName
    _self.model.orderNumber = response.data.orderNumber
    _self.model.shortDescription = response.data.shortDescription
    _self.model.enShortDescription = response.data.enShortDescription
    _self.model.longDescription = response.data.longDescription
    _self.model.enLongDescription = response.data.enLongDescription
    _self.model.imageMain = response.data.imageMain
    _self.model.creditForUse = response.data.creditForUse
    _self.model.isCreditType = response.data.isCreditType
    _self.model.purchasePrice = response.data.purchasePrice
    _self.model.stockNumber = response.data.stockNumber != null ? response.data.stockNumber : 0;
    _self.model.additionalInfo.price = addInfo.price
    _self.model.additionalInfo.currency = addInfo.currency
    _self.model.additionalInfo.discount = addInfo.discount
    _self.model.additionalInfo.shopLink = addInfo.shopLink
    _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
    // _self.visibleStockNumber = (response.data.creditForUse <= 1 || response.data.isCreditType === true) && (this.isMainAdmin || this.isEnableAddStockNumber)
    _self.getAllCategories(true)
}

function populateItemToMakeAction(response){
    let _self = this;
    let addInfo = JSON.parse(response.data.additionalInfo)
    _self.imageUrl = response.data.imageMain
    // _self.model.name = response.data.name
    // _self.model.enName = response.data.enName
    _self.model.orderNumber = response.data.orderNumber
    _self.model.category = response.data.category
    _self.model.shortDescription = response.data.shortDescription
    _self.model.enShortDescription = response.data.enShortDescription
    _self.model.longDescription = response.data.longDescription
    _self.model.enLongDescription = response.data.enLongDescription
    _self.model.imageMain = response.data.imageMain
    _self.model.isCreditType = response.data.isCreditType
    _self.model.creditForUse = 1
    _self.model.stockNumber = response.data.stockNumber != null ? response.data.stockNumber : 0;
    _self.model.orderUuid = response.data.orderUuid
    // _self.model.additionalInfo.price = addInfo.price
    // _self.model.additionalInfo.currency = addInfo.currency
    // _self.model.additionalInfo.discount = addInfo.discount
    _self.model.additionalInfo.shopLink = addInfo.shopLink
    _self.selectedCustomCategories = response.data.locations == null ? [] : response.data.locations.split(";").filter(e => e.length > 0)
    _self.idToEdit = null
    // _self.visibleStockNumber = false
}

function addTraining() {
    if(this.idToEdit != null){
        this.editTraining();
        return;
    }
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' || (!this.isAction && _self.selectedImage == null)) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });

    if(_self.isAction){
        _self.addTrainingFromApi(_self.model.imageMain);
    }else{
        _self.uploadPhoto(false);
    }

}

function editTraining(){
    let _self = this;
    if (_self.model.name === '' || _self.model.shortDescription === '' ) {
        swal(LocService.t("label_error"), LocService.t('label_ci_training_required'), 'error')
        return;
    }
    swal({
        title: "",
        text: "",
        type: "",
        // html: "<div style='position: relative'><div class=\"loader\"></div></div>",
        html: "<div style='margin-top: 20%;' class=\"lds-roller\"><div></div><div></div><div></div><div></div><div></div><div></div><div></div><div></div></div><div>Molimo sačekajte</div>",
        showCancelButton: false,
        showConfirmButton: false,
        allowOutsideClick: false,
        allowEscapeKey: false,
        customClass: 'swal-custom'
    }, function (selection) {
    });
    if(_self.selectedImage != null){
        _self.uploadPhoto(true)
    }else{
        _self.editTrainingFromApi(_self.model.imageMain)
    }
}

function uploadPhoto(isEdit) {
    let _self = this;
    AdminApiService.uploadImageCompanyInfo(this.selectedImage)
        .then((response) => {
            if(isEdit){
                _self.editTrainingFromApi(response.data.url)
            }else{
                _self.addTrainingFromApi(response.data.url);
            }

        })
        .catch((error) => {
            swal(LocService.t('label_error'), LocService.t('label_image_upload_error'), 'error')
        })
}

function editTrainingFromApi(url) {
    if(this.model.additionalInfo.discount != null
        && (this.model.additionalInfo.discount.length === 0 || this.model.additionalInfo.discount === 0)){
        this.model.additionalInfo.discount = null
    }
    let _self = this;
    this.model.category = this.selectedCategory != null ? this.selectedCategory.name : null;
    let modelToSend = {
        id: this.idToEdit,
        name: this.model.name,
        enName: this.model.enName,
        category: this.model.category,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        shortDescription: this.model.shortDescription,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        creditForUse: this.model.creditForUse,
        isCreditType: this.model.isCreditType,
        stockNumber: this.model.stockNumber,
        price: this.model.additionalInfo.price != null ? this.model.additionalInfo.price : 0,
        purchasePrice: this.model.purchasePrice,
        discount: this.model.additionalInfo.discount != null ? this.model.additionalInfo.discount : 0,
        additionalInfo: JSON.stringify(this.model.additionalInfo),
        imageHeader: null,
        imageMain: url,
        type: 'SHOP',
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.updateCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_shop_success_add'), 'success')
            _self.$router.push('/shop');
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function addTrainingFromApi(url) {
    if(this.model.additionalInfo.discount != null
        && (this.model.additionalInfo.discount.length === 0 || this.model.additionalInfo.discount === 0)){
        this.model.additionalInfo.discount = null
    }
    this.model.category = this.selectedCategory != null ? this.selectedCategory.name : null;
    let _self = this;
    let modelToSend = {
        name: this.model.name,
        enName: this.model.enName,
        category: this.model.category,
        shortDescription: this.model.shortDescription,
        orderNumber: this.model.orderNumber <= 0 ? null : this.model.orderNumber,
        enShortDescription: this.model.enShortDescription,
        longDescription: this.model.longDescription,
        enLongDescription: this.model.enLongDescription,
        creditForUse: this.model.creditForUse,
        isCreditType: this.model.isCreditType,
        stockNumber: this.model.stockNumber,
        purchasePrice: this.model.purchasePrice,
        price: this.model.additionalInfo.price != null ? this.model.additionalInfo.price : 0,
        discount: this.model.additionalInfo.discount != null ? this.model.additionalInfo.discount : 0,
        additionalInfo: JSON.stringify(this.model.additionalInfo),
        imageHeader: null,
        imageMain: url,
        type: 'SHOP',
        parentOrderUuid: this.isAction ? this.model.orderUuid : null,
        locations: UTILS.formatSelectedLocations(_self.selectedCustomCategories)
    }
    AdminApiService.addCompanyInfoTraining(modelToSend)
        .then((response) => {
            _self.reset();
            swal(LocService.t("label_success"), LocService.t('label_ci_training_success_add'), 'success')
            _self.$router.push('/shop');
        })
        .catch(error => {
            swal(LocService.t("label_error"), error.data.localized_error_message, 'error')
        })
}

function reset() {
    this.selectedImage = null
    this.selectedImagePreview = null
    this.imageUrl = null
    this.model = {
        name: '',
        enName: '',
        shortDescription: '',
        enShortDescription: '',
        longDescription: '',
        enLongDescription: '',
        imageHeader: null,
        category: null,
        isCreditType: false,
        stockNumber: 0,
        imageMain: '',
        type: 'SHOP',
        locations: null,
        purchasePrice: null
    }
}


function loadTextFromFile(ev) {
    var i = 0;
    for (i = 0; i < ev.target.files.length; i++) {
        const file = ev.target.files[i];
        if (file.size > 5000000) {
            alert(this.locale.t('label_max_size_picture'))
            return
        }
        const reader = new FileReader();
        this.selectedImage = file;
        this.selectedImagePreview = URL.createObjectURL(file);
        reader.onload = e => {
            // console.log(e.target.result);
            // _self.files.push(e.target.result);
        }

        reader.readAsDataURL(file);

    }

}

function getChipClass(item) {
    if (this.selectedCustomCategories.includes(item)) {
        return 'chip-selected'
    }
    return 'chip-unselected'
}

function isSelected(item) {
    return this.selectedCustomCategories.includes(item)
}

function clickSelectCustomCategory(item) {
    if (this.selectedCustomCategories.includes(item)) {
        this.selectedCustomCategories = this.selectedCustomCategories.filter(e => e !== item)
    } else {
        this.selectedCustomCategories.push(item)
        if(this.selectedCustomCategories.length === this.allCustomCategories.length){
            this.selectedCustomCategories = []
        }
    }
}






// WEBPACK FOOTER //
// ./src/components/Home/Add/AddShopInfo.js